module.exports = __webpack_public_path__ + "static/media/AM3.9e847b62.jpg";